import { render, staticRenderFns } from "./ChoosePreferredPhoto.vue?vue&type=template&id=6c4fb290&"
import script from "./ChoosePreferredPhoto.vue?vue&type=script&lang=js&"
export * from "./ChoosePreferredPhoto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports